/**
 * Text/Textarea input component for questions
 */
export const TextInput = ({ questionId, value, onChange, placeholder, disabled, saving }) => {
  return (
    <div>
      <textarea
        value={value || ''}
        onChange={(e) => onChange(questionId, 'answer', e.target.value)}
        placeholder={placeholder}
        rows={3}
        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-emerald-500 dark:focus:ring-emerald-400 focus:border-emerald-500 dark:focus:border-emerald-400 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500"
        disabled={disabled || saving}
      />
    </div>
  );
};

